module.exports = __webpack_public_path__ + "static/media/uber.416851d6.png";